import * as constants from './constants';

export const vehicleControlInitialState = {
  activeRequests: null,
  history: null,
  details: {},
};

const vehicleControlReducer = (
  state = vehicleControlInitialState,
  { type, payload } = {},
) => {
  switch (type) {
    case constants.POST_VEHICLE_CONTROL_REQUEST:
      return {
        ...state,
        ...payload,
      };
    case constants.GET_VEHICLE_CONTROL_REQUEST:
      return {
        ...state,
        details: { ...state.details, ...payload },
      };
    case constants.GET_VEHICLE_CONTROL_HISTORY:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};

export default vehicleControlReducer;
